import ReactDOM from "react-dom/client";
import { useState, useEffect, createContext } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import axios from "axios"
import Layout from "./pages/Layout";
import Login from "./pages/Login";
import Logout from "./pages/Logout";
import Home from "./pages/Home";
import NewsAdd from "./pages/NewsAdd"
import Documents from "./pages/Documents"
import DocumentAdd from "./pages/DocumentAdd"
import ArticleAdvices from "./pages/ArticleAdvices"
import ArticleContacts from "./pages/ArticleContacts"
import ArticleEmergency from "./pages/ArticleEmergency"
import ArticleUpdate from "./pages/ArticleUpdate"
import Users from "./pages/Users";
import PasswordChange from "./pages/PasswordChange";
import PasswordForgotten from "./pages/PasswordForgotten";
import PasswordReset from "./pages/PasswordReset";
import UserRegistration from "./pages/UserRegistration";
import NoPage from "./pages/NoPage";
import ScrollToTop from "./utils/ScrollToTop";

export const apiRoot ='/api/v1/index.php';

export const UserContext = createContext();
export const SetUserContext = createContext();

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
    },
  },
});

export function getUserFromDbUser(dbUser) {
  if (dbUser) {
    return {
      userId: dbUser['userId'],
      name: dbUser['name'],
      appartmentNo: dbUser['appartmentNo'],
      isCommittee: dbUser['isCommittee'],
      isAdmin: dbUser['isAdmin'],
      isPowerUser: dbUser['isCommittee'] || dbUser['isAdmin'],
      isNotified: dbUser['isNotified']
    }
  } else {
    return null;
  }
}

export default function App() {
  const [user, setUser] = useState(null);
  
  useEffect(() => {
    async function fetchCurrentUser() {
      const jwtToken = window.sessionStorage.getItem('jwtToken');
      if (jwtToken) {
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + jwtToken; // TODO
        setUser(getUserFromDbUser((await axios.get(apiRoot + '/login/user')).data));
      }
    }
    fetchCurrentUser();
  }, []);

  return (
    <UserContext.Provider value={user}>
      <SetUserContext.Provider value={setUser}>
        <QueryClientProvider client={queryClient}>
          <BrowserRouter basename="/">
            <ScrollToTop />
            <Routes>
              <Route element={<Layout />}>
                <Route index element={user ? <Home /> : <Login />} />
                <Route path="/aktuality" element={<Home />} />
                <Route path="/pridat-aktualitu" element={<NewsAdd />} />
                <Route path="/dokumenty" element={<Documents />} />
                <Route path="/pridat-dokument" element={<DocumentAdd />} />
                <Route path="/havarijni-sluzby" element={<ArticleEmergency />} />
                <Route path="/kontakty" element={<ArticleContacts />} />
                <Route path="/koutek-dobrych-rad" element={<ArticleAdvices />} />
                <Route path="/upravit-clanek" element={<ArticleUpdate />} />
                <Route path="/uzivatele" element={<Users />} />
                <Route path="/zmena-hesla" element={<PasswordChange />} />
                <Route path="/odhlasit" element={<Logout />} />
                <Route path="/zapomenute-heslo" element={<PasswordForgotten />} />
                <Route path="/reset-hesla" element={<PasswordReset />} />
                <Route path="/registrace-uzivatele" element={<UserRegistration />} />
                <Route path="*" element={<NoPage />} />
              </Route>
            </Routes>
          </BrowserRouter>
        </QueryClientProvider>
      </SetUserContext.Provider>
    </UserContext.Provider>
  );
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);